/**
 * Preferencias de la impresora de tickets de esta caja (se guardan en este
 * navegador).
 *
 * El navegador NO deja que una pagina elija impresora: imprime en la
 * predeterminada del sistema. Y solo se salta el dialogo de impresion si se
 * arranca con --kiosk-printing. Aqui solo se guarda lo que la pagina si decide:
 * el ancho del rollo.
 */
export type PaperWidthMm = 58 | 80;

export const PAPER_WIDTH_KEY = 'tpv_printer_paper_mm';
export const DEFAULT_PAPER_WIDTH: PaperWidthMm = 80;

export const readPaperWidth = (): PaperWidthMm => {
    try {
        return localStorage.getItem(PAPER_WIDTH_KEY) === '58' ? 58 : DEFAULT_PAPER_WIDTH;
    } catch {
        return DEFAULT_PAPER_WIDTH;
    }
};

export const savePaperWidth = (width: PaperWidthMm): void => {
    try {
        localStorage.setItem(PAPER_WIDTH_KEY, String(width));
    } catch { /* sin persistencia: vuelve a 80 mm al recargar */ }
};
